import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import axios from 'axios'
import toastStore from '@/stores/toast-store.js'

export default {
  name: 'CollectPackageScreen',
  extends: BaseModal,
  data: function () {
    return {
      cp: null,
      cpus: [],
      selectedCpu: null,
    }
  },
  mounted() {
    this.drawCollectionPoint(this.data.cpId)
  },
  computed: {
    modalTitle() {
      if (this.data.type == 'locker') {
        return this.$t('collectPackageModalForLockers.title')
      } else if (this.data.type == 'delivery') {
        return this.$t('collectPackageModalForDelivery.title')
      } else {
        return ''
      }
    },
    modalDescription() {
      if (this.data.type == 'locker') {
        return this.$t('collectPackageModalForLockers.description')
      } else if (this.data.type == 'delivery') {
        return this.$t('collectPackageModalForDelivery.description')
      } else {
        return ''
      }
    },
  },
  methods: {
    drawCollectionPoint() {
      axios({
        method: 'get',
        url: `collection_points/${this.data.cpId}/display_content`,
      })
        .then(response => {
          console.log('drawCollectionPoint', response)
          this.cp = response.data
          this.cpus = this.parseCpus(response.data.units).sort(this.sortCpus)
          this.selectedCpu = this.cpus.filter(cpu => {
            return _.map(cpu.boxes, 'id').indexOf(this.data.boxId) != -1
          })[0]
        })
        .catch(error => {
          toastStore.commit('error', { message: this.$t('messages.error') })
        })
    },

    parseCpus(cpus) {
      // additional step for master-slave boxes, we move them to one cpu
      if (_.map(cpus, 'kind').indexOf('slave') != -1) {
        let masters = cpus.filter(cpu => cpu.kind == 'master')
        let slaves = cpus.filter(cpu => cpu.kind == 'slave')

        let myMasters = this.awakenMyMasters(masters, slaves)
        return myMasters
      } else {
        return cpus
      }
    },

    sortCpus(a, b) {
      return parseFloat(a.position) - parseFloat(b.position)
    },

    awakenMyMasters(masters, slaves) {
      return masters.map(master => {
        let belongingSlaves = slaves.filter(slave => slave.masterId == master.id)
        belongingSlaves.forEach(slave => {
          slave.boxes.forEach(box => {
            master.boxes.push(box)
          })
        })

        return master
      })
    },
    calculateCpuWidth() {
      return this.$refs.modal.clientWidth
    },
  },
  components: {
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
    CpuWireframe: () => import('@/vcs/_shared/cpu-wireframe/cmp.vue'),
  },
}
